import { Injectable } from '@angular/core';
import {
  UntypedFormControl,
  UntypedFormGroup,
  Validators
} from '@angular/forms';
import {
  RecoveryOptionsContent,
  RecoveryOptionsPageContent
} from '@com-delta-idp/mnx-login-ui';
import { LoginHelperUtils } from '../../../utils/login-helper.utils';
import { LOGIN_CONSTANTS } from '../../constants/login-constant';
import { LoginModalContent } from '../../models/aem';
import { ResetPasswordUserResponse } from '../../models/reset-password-api.interface';

@Injectable({
  providedIn: 'root'
})
export class RecoveryOptionsAdapter {
  recoveryOptionsForm!: UntypedFormGroup;
  constructor(private loginHelperUtils: LoginHelperUtils) {}

  geRecoveryOptionsContent(
    loginAemResponse: LoginModalContent,
    bffResponse: ResetPasswordUserResponse
  ): RecoveryOptionsContent {
    return {
      formGroup: this.createRecoveryOptionsForm(),
      pageContent: this.getRecoveryOptionsPageContent(
        loginAemResponse,
        bffResponse?.email
      ),
      hasError: false,
      errorMessage: '',
      disabledActionButton: false
    };
  }

  /** Recovery option content */
  createRecoveryOptionsForm(): UntypedFormGroup {
    this.recoveryOptionsForm = new UntypedFormGroup({
      options: new UntypedFormControl(
        {
          value: LOGIN_CONSTANTS.RECOVERY_OPTION_EMAIL
        },
        [Validators.required]
      )
    });
    return this.recoveryOptionsForm;
  }

  getRecoveryOptionsFormGroup(): UntypedFormGroup {
    return this.recoveryOptionsForm;
  }

  getRecoveryOptionsPageContent(
    aemResponse: LoginModalContent,
    maskedEmail: string | undefined
  ): RecoveryOptionsPageContent {
    const { chooseRecoveryOptions, pageHeader } = aemResponse;

    return {
      ...chooseRecoveryOptions,
      pageHeader: {
        ...pageHeader,
        headerTitle: chooseRecoveryOptions.headerTitle,
        headerSubTitle: chooseRecoveryOptions.headerSubTitle
      },
      emailLabel: maskedEmail
        ? this.loginHelperUtils.maskEmail(
            chooseRecoveryOptions.recoveryMethodLabel_Email,
            maskedEmail
          )
        : chooseRecoveryOptions.recoveryMethodLabel_Email,
      sqaLabel: chooseRecoveryOptions.recoveryMethodLabel_SQA,
      emailText: LOGIN_CONSTANTS.RECOVERY_OPTION_EMAIL,
      sqaText: LOGIN_CONSTANTS.RECOVERY_OPTION_SQA,
      buttonLabel: chooseRecoveryOptions.nextDisplayView.button_modal
    };
  }
}
